const getCssVariableValue = (variableName: string): string =>
    getComputedStyle(document.documentElement).getPropertyValue(variableName);

export default getCssVariableValue;
